import * as React from "react";
const SvgLuggage = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18 7V1H7v6H5v16h4v-1h7v1h4V7h-2Zm-8-3h5v3h-5V4Z", fill: "#000" }));
export default SvgLuggage;
